import { Component, OnInit, Input, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { Afiliaciones } from '../../../../models/afiliaciones';
import { AfiliacionesDetalleComponent } from '../afiliaciones-detalle/afiliaciones-detalle.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { AfiliacionesService } from '../../../../services/afiliaciones.service';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-afiliaciones-cab',
  templateUrl: './afiliaciones-cab.component.html',
  styleUrls: ['./afiliaciones-cab.component.css']
})
export class AfiliacionesCabComponent implements OnInit, OnChanges {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  afiliacion: Afiliaciones;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  afiliacionesHistoryList: any;
  afiliacionesList: Afiliaciones[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  afiliaciones: Afiliaciones[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  afiliacionesInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildAfiliacionDetalle') afiliacionDetalle: AfiliacionesDetalleComponent;

  constructor(private afiliacionesService: AfiliacionesService, 
              private dialog: MatDialog, 
              private erroresService: ErroresService, 
              private snackBar: MatSnackBar, 
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerAfiliaciones(false);
    
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Afiliaciones")) this.permisoEdicion = true;
  }

  obtenerAfiliaciones(agrupar)
  {
    this.buscando = true;
    this.afiliacionesService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.afiliaciones = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(afiliacion)
  {
    if (afiliacion.id != 0)
    {
      this.obtenerHistorial(afiliacion);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.afiliacion = afiliacion;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.afiliacion))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.afiliacionesService.eliminar(this.afiliacion.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let afiliacion = this.afiliacionesList.filter(d => d.id != this.afiliacion.id)[0];
              if (afiliacion == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(afiliacion);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.afiliacion))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.afiliacionDetalle.form.controls['desde'].disable();
        $this.afiliacionDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let afiliacion = this.afiliacionesList.find(d => d.id == index);
    this.afiliacion = afiliacion;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.afiliacionDetalle.setearForm(this.afiliacion);
    this.deshabilitarEdicion();
  }

  async OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.afiliacionDetalle.form.getRawValue();

      let datosAfi: Afiliaciones = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        claseAfiliaciones: formulario.claseAfiliaciones,
        descripcion: formulario.descripcion
      };

      this.afiliacionesService.guardar(datosAfi, this.cortarRegistro).subscribe(
        afiliacion =>
        {
          afiliacion.desde = this.momentService.convertDateServer(afiliacion.desde);
          afiliacion.hasta = this.momentService.convertDateServer(afiliacion.hasta);
          
          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Afiliación guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(afiliacion);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //afiliacion.desde = afiliacion.desde.replace('Z', '');
          this.afiliacionDetalle.setearForm(afiliacion);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.afiliacionDetalle.form.controls['id'].setValue(0);
      this.afiliacionDetalle.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.afiliacionDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.afiliacionesHistoryList = [];
    this.afiliacionesList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerAfiliaciones(false);
  }

  private obtenerHistorial(afiliacion: Afiliaciones)
  {
    this.afiliacionesService.getHistoryByClase(afiliacion.personal, afiliacion.claseAfiliaciones).subscribe(
      afiliaciones =>
      {
        afiliaciones.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.afiliacionesHistoryList = [];
        afiliaciones.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.afiliacionesHistoryList.push(item);
        });

        this.afiliacionesList = afiliaciones;
        this.verDetalle = true;
        this.afiliacion = afiliacion;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.afiliacionDetalle.form.get("desde").value.toDateString();
    let hasta = this.afiliacionDetalle.form.get("hasta").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.afiliacionDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.afiliacionDetalle.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.afiliacionDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.afiliacionDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK", { duration: 10000 });
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
  
}
